import { render, staticRenderFns } from "./Viewmodal.vue?vue&type=template&id=32be3afa&"
import script from "./Viewmodal.vue?vue&type=script&lang=js&"
export * from "./Viewmodal.vue?vue&type=script&lang=js&"
import style0 from "./Viewmodal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports